import React, { useEffect } from 'react';
import classes from './SelectConnection.module.scss';
import { ListItemText, MenuItem, MenuList } from '@mui/material';
import useSelectConnection from 'new/elements/flows/SelectConnection/useSelectConnection';

interface CategoriesProps {
  fixedCategory?: string;
}

export const Categories = (props: CategoriesProps) => {
  const { categories, selectedCategory, setSelectedCategory } = useSelectConnection();

  useEffect(() => {
    if (props.fixedCategory) {
      setSelectedCategory(props.fixedCategory);
    }
  }, []);

  const onClickItem = (category: string) => () => {
    if (!props.fixedCategory) {
      setSelectedCategory(category);
    }
  };

  return (
    <aside data-testid="categoriesContainer" className={classes.categories}>
      <MenuList>
        {categories.map((category) => (
          <MenuItem
            key={category}
            onClick={onClickItem(category)}
            disabled={props.fixedCategory && props.fixedCategory !== category}
            selected={selectedCategory === category}
          >
            <ListItemText>{category}</ListItemText>
          </MenuItem>
        ))}
      </MenuList>
    </aside>
  );
};
